import { Switch } from "antd";
import React from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { device } from "../globalAssets/breakpoints";
import { mode, toggleDark, toggleLight } from "./slice/modeSlice";

export const DarkModeToggler: React.FC = () => {
  const lightmode = useAppSelector(mode);

  const dispatcher = useAppDispatch();
  const onChange = (): void => {
    lightmode === "dark" ? dispatcher(toggleLight()) : dispatcher(toggleDark());
  };
  return (
    <Container>
      <StyledSwitch
        onChange={onChange}
        // checkedChildren="☀️"
        // unCheckedChildren="🌙"
        checkedChildren="light"
        unCheckedChildren="dark"
        defaultChecked={lightmode === "light" ? true : false}
      />
    </Container>
  );
};
const StyledSwitch: any = styled(Switch)`
  background: rgba(16, 171, 222, 0.5);
  cursor: pointer;
`;

const Container = styled.div`
  margin: 0;
  @media ${device.laptop} {
    margin-right: 15px;
  }
`;
